import * as React from 'react';
import { Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import GenericButton from '../genericButton/genericButton';

interface IGenericModalProps {
  modalWindowId: string;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  primaryButtonAction?: () => void;
  secondaryButtonAction?: () => void;
  title: string;
  isOpen: boolean;
}

class GenericModal extends React.Component<IGenericModalProps, {}> {

  public render() {
    const { modalWindowId, primaryButtonText, secondaryButtonText, primaryButtonAction, secondaryButtonAction, title, isOpen } = this.props;
    // toggle={props.enabledEvent.bind(props.modalWindowId)}
    return <Row>
      <Col sm={12}>
        <Modal

          id={modalWindowId}
          className={`ModalWindow modal-md`}
          isOpen={isOpen}
          autoFocus={true}
          backdrop={'static'}
          keyboard={false}
        >
          <ModalHeader>
            <span id={modalWindowId+"Header"} className="h2">{title}</span>
          </ModalHeader>
          <ModalBody id={modalWindowId+"Body"}>{this.props.children}</ModalBody>
          <ModalFooter id={modalWindowId+"Footer"}>
            {primaryButtonText && primaryButtonAction && <GenericButton
              isOnBackground={true}
              name={primaryButtonText}
              variant="primary"
              type="button"
              iconClassNameRight="fa fa-angle-right fa-x2"
              className="float-left marginRight20 primaryButton"
              clickEvent={primaryButtonAction}
              id="primaryButton"
            />}

            {secondaryButtonText && secondaryButtonAction && <GenericButton
              isOnBackground={true}
              name={secondaryButtonText}
              type="button"
              clickEvent={secondaryButtonAction}
              variant="secondary"
              className="float-left marginRight20 noButton secondaryButton"
              id="secondaryButton"
            />}
          </ModalFooter>
        </Modal>
      </Col>
    </Row>
  }
}

export default GenericModal;


// WEBPACK FOOTER //
// ./src/components/shared/genericModal/genericModal.tsx